import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const getLineKey = (it) =>
    it?.lineKey || (it?.skuId != null ? `${it?.id}_${it.skuId}` : String(it?.id));

  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem("cartItems");
    const parsed = saved ? JSON.parse(saved) : [];
    return Array.isArray(parsed)
      ? parsed.map((it) => {
          if (!it) return it;
          let rest = it.qty == null && it.quantity != null
            ? (() => { const { quantity, ...r } = it; return { ...r, qty: quantity }; })()
            : { ...it };
          if (!rest.lineKey) rest = { ...rest, lineKey: rest.skuId != null ? `${rest.id}_${rest.skuId}` : String(rest.id) };
          return rest;
        })
      : [];
  });

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(items));
  }, [items]);

  const addProduct = (item) => {
    setItems((prev) => {
      const makeSig = (x) =>
        x && x.sku
          ? String(x.sku)
          : JSON.stringify({
              title: x?.title,
              price: x?.price,
              options: x?.options,
            });
      const sig = makeSig(item);
      const idx = prev.findIndex((x) => makeSig(x) === sig);
      if (idx >= 0) {
        const next = prev.slice();
        const merged = {
          ...next[idx],
          qty: (Number(next[idx].qty) || 0) + (Number(item.qty) || 0),
        };
        next[idx] = merged;
        return next;
      }
      return [...prev, item];
    });
  };

  const removeProduct = (idOrLineKey) => {
    setItems((prev) =>
      prev.filter((x) => getLineKey(x) !== idOrLineKey && x.id !== idOrLineKey)
    );
  };

  const updateItemQty = (idOrLineKey, qty) => {
    setItems((prev) =>
      prev.map((x) =>
        getLineKey(x) === idOrLineKey || x.id === idOrLineKey
          ? { ...x, qty: Number(qty) || 1 }
          : x
      )
    );
  };

  const clearCart = () => {
    setItems([]);
    localStorage.setItem("cartItems", JSON.stringify([]));
  };

  return (
    <CartContext.Provider
      value={{
        items,
        addProduct,
        removeProduct,
        clearCart,
        updateItemQty,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
